import { PageHeader } from 'antd'

import { Box } from 'atom/box'
import { BackgroundContainer } from 'atom/layout/backgroundContainer'

import { AlertError } from 'components/error'
import { withAuthenticatedLayout } from 'components/layouts/layout'
import { Links } from 'components/routes/paths'

import TenantsAllSelectors from 'features/tenants/TenantsAllSelectors'
import TenantsTable from 'features/tenants/TenantsTable'

import { ButtonModal } from 'atom/button'
import { useTenantTranslation } from 'hooks/translation/useTenantTranslation'
import { useTenants } from 'hooks/useTenants'
import { useHistory } from 'react-router'
import { plusSVG } from 'assets/svg/plus'
import { useAppState } from 'state'

const TenantsBasePage: React.FC = () => {
  document.querySelector('body')?.classList.add('redesignActive')

  const { currentUser } = useAppState()
  const { createNewTenantBtn } = useTenantTranslation()
  const history = useHistory()

  const {
    loading,
    tenants,
    error,
    pagination,
    filter,
    handleFilterChange,
    fetchTenants,
    handlePaginationChange,
    handleLocationChange,
  } = useTenants()

  const renderTitle = () => (
    <TenantsAllSelectors
      loading={loading}
      filter={filter}
      tenants={tenants}
      onFilterChange={handleFilterChange}
      fetchData={fetchTenants()}
      onLocationChange={handleLocationChange}
      dropdownClassName="not-in-modal-selector"
    />
  )

  return (
    <BackgroundContainer>
      <PageHeader
        title={renderTitle()}
        extra={
          currentUser?.role === 'admin' && (
            <ButtonModal
              size="large"
              disabled={loading}
              click={() => history.push(Links.tenantsCreate())}
              text={createNewTenantBtn}
              type="primary"
              icon={plusSVG}
            />
          )
        }
      />
      <AlertError error={error} />
      <Box>
        <TenantsTable
          loading={loading}
          tenants={tenants}
          pagination={pagination}
          onPaginationChange={handlePaginationChange}
        />
      </Box>
    </BackgroundContainer>
  )
}

export const TenantsPage = withAuthenticatedLayout(TenantsBasePage)
